import styled from 'styled-components';

export const Container = styled.span`
  align-self: flex-end;
  color: ${({ theme }) => theme.colors.grey400};
  font-size: 1.25rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  padding-bottom: 0.3125rem;
`;
